import graphqlClient from "../../../apollo";

class ImportarProductosProvider {
  validar(proveedorId, depositoId, modo, rows) {
    return graphqlClient.query({
      query: require("./gql/productoImportarValidar.graphql"),
      variables: { proveedorId, depositoId, modo, rows },
      fetchPolicy: "network-only",
    });
  }

  importarBulk(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/productoImportarBulk.graphql"),
      variables: { input },
    });
  }
}

export default new ImportarProductosProvider();
